import { memoize } from 'lodash-es';

const initializeRUM = async () => {
  const { AwsRum } = await import('aws-rum-web');

  return new AwsRum(
    '19cfd007-a373-403a-bec1-5ce59aa3729a',
    '1.0.0',
    'us-west-2',
    {
      sessionSampleRate: 1,
      guestRoleArn: 'arn:aws:iam::358103606445:role/gamma-us-west-2-GrowThriv-GTCHubgammaRUMIdentityPoo-CYaGiZmkoKCG',
      identityPoolId: 'us-west-2:b7c4b7f1-4eae-4927-b609-46dd19e528d4',
      endpoint: `https://dataplane.rum.us-west-2.amazonaws.com`,
      telemetries: [
        'performance',
        'errors',
        ['http', { recordAllRequests: true }],
      ],
      allowCookies: true,
      sessionEventLimit: 0,
      enableXRay: true,
      enableRumClient: true,
      // https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-RUM-custom-metadata.html
      sessionAttributes: {
        userAgent: navigator.userAgent,
      },
    },
  );
};

// https://github.com/aws-observability/aws-rum-web/blob/main/docs/configuration.md
export const getAwsRumInstance = memoize(initializeRUM);
